import { motion } from "framer-motion";

export default function KpiCard({ label, value, sub, icon: Icon, tone = "neutral", delay = 0, testId, big = false }) {
  const toneColor = tone === "profit" ? "#10B981" : tone === "loss" ? "#EF4444" : "#D4AF37";
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay, ease: [0.22, 1, 0.36, 1] }}
      className="dlx-card dlx-grain overflow-hidden p-5 sm:p-6"
      data-testid={testId}
    >
      <div className="flex items-start justify-between">
        <span className="font-sans text-[10px] font-medium uppercase tracking-[0.2em] text-zinc-500">
          {label}
        </span>
        {Icon && (
          <span className="rounded-md border border-white/5 bg-white/[0.02] p-1.5">
            <Icon size={14} style={{ color: "#D4AF37" }} />
          </span>
        )}
      </div>
      <div className={`mt-4 font-mono font-bold tracking-tight ${big ? "text-3xl sm:text-4xl" : "text-2xl sm:text-[26px]"}`}
        style={{ color: tone === "neutral" ? "#fff" : toneColor }}>
        {value}
      </div>
      {sub != null && (
        <div className="mt-1.5 font-sans text-xs text-zinc-500">{sub}</div>
      )}
    </motion.div>
  );
}
